import client from './client';

export const getReactions = async (activityId) => {
    const response = await client.get(`/activities/${activityId}/reactions`);
    return response.data;
};

export const getReactionsBatch = async (activityIds) => {
    const response = await client.post('/activities/reactions/batch', { activity_ids: activityIds });
    return response.data;
};

export const getAllowedEmojis = async () => {
    const response = await client.get('/activities/reactions/emojis');
    return response.data.emojis;
};

export const toggleReaction = async (activityId, emoji) => {
    const response = await client.post(`/activities/${activityId}/reactions`, { emoji });
    return response.data;
};
